import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { chunk } from 'lodash';
import { Column, Row } from 'hedron';
import { SectionLink, SectionLinksRowWrapper } from './styled';
import { Desktop, Mobile } from '../MediaQuery';

class DesignerListSectionLinks extends Component {
  createSectionLink(letter, onClick) {
    const { availableAlphabet } = this.props;

    return (
      <SectionLink active={availableAlphabet.indexOf(letter) !== -1} key={letter} onClick={() => onClick(letter)}>
        {letter}
      </SectionLink>
    );
  }

  render() {
    const { alphabet, onClickDesktop, onClickMobile } = this.props;

    const rowsCount = 3;
    const columnsCount = Math.ceil(alphabet.length / rowsCount);
    const letterRows = chunk(alphabet, columnsCount);

    return (
      <Row divisions={rowsCount} fluid>
        {letterRows.map(letterRow => (
          <Column xs={rowsCount} lg={1} divisions={rowsCount} fluid>
            <SectionLinksRowWrapper>
              {letterRow.map(letter => {
                return (
                  <>
                    <Desktop>{this.createSectionLink(letter, onClickDesktop)}</Desktop>
                    <Mobile>{this.createSectionLink(letter, onClickMobile)}</Mobile>
                  </>
                );
              })}
            </SectionLinksRowWrapper>
          </Column>
        ))}
      </Row>
    );
  }
}

DesignerListSectionLinks.propTypes = {
  alphabet: PropTypes.arrayOf(PropTypes.string).isRequired,
  availableAlphabet: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClickDesktop: PropTypes.func.isRequired,
  onClickMobile: PropTypes.func.isRequired,
};

export default DesignerListSectionLinks;
